export default "__VITE_ASSET__DN_NvXm2__"